module.exports = __webpack_public_path__ + "static/media/IMG_0100.450af566.JPG";